import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import qs, { ParsedQs } from 'qs';

const preserveLeadingPlus = (search: string): string => search.replace(/=\+(\d)/g, '=%2B$1');

const useQueryParams = () => {
    const [params, setParams] = useState<ParsedQs>({});
    const location = useLocation();

    useEffect(() => {
        setParams(qs.parse(preserveLeadingPlus(location?.search || ''), { ignoreQueryPrefix: true }));
    }, [location]);

    return params;
};

export default useQueryParams;
